/**
 * Returns a localized error title string based on the given error type.
 * @param {PageErrorProps['type']} type - The type of error (e.g., 'not-found', 'access-issue').
 * @param {TFunction<'common-web-ui', undefined>} t - The translation function for retrieving localized strings.
 * @returns {string} The localized error title.
 */
export function getDefaultErrorTitle(type, t) {
    switch (type) {
        case 'not-found':
            return t('pageError.titleNotFound');
        case 'access-issue':
            return t('pageError.titleAccessIssue');
        default:
            return t('pageError.title');
    }
}
